import { io } from 'socket.io-client';

let socket = null;

export const initializeSocket = () => {
  if (!socket) {
    try {
      socket = io(process.env.REACT_APP_SOCKET_API, {
        transports: ['websocket'],
        query: { userId: localStorage.getItem('token') || '' },
        autoConnect: true,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 500,
      });
      console.log('socket API', process.env.REACT_APP_SOCKET_API);

      socket.on('connect', () => {
        console.log('WebSocket connected');
      });

      socket.io.on('error', (error) => {
        if (process.env.NODE_ENV !== 'development') {
          console.log(
            'WebSocket connection error (suppressed):',
            error.message,
          );
        }
      });

      socket.on('disconnect', (reason) => {
        console.warn('WebSocket disconnected:', reason);
        if (reason === 'io server disconnect') {
          socket.connect();
        }
      });
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to initialize WebSocket:', err.message);
      }
    }
  }
  return socket;
};

export const getSocket = () => {
  if (!socket) {
    console.warn('Socket not initialized. Call initializeSocket first.');
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log('WebSocket disconnected');
  }
};
